module.exports = __webpack_public_path__ + "img/img_default330.png";